import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import { IUICfgAttributeBoolean } from '@canvas-logic/clp-api-types';
import { AttributeStateBase } from '@/elements/base/AttributeStateBase';

let id = 0;

export class BooleanAttributeState extends AttributeStateBase<IUICfgAttributeBoolean, boolean> {
  readonly elementKind = 'attribute';
  readonly elementType = 'boolean';
  public id = 'boolean-view-state-' + ++id;

  constructor(api: ICompositeProductApi, element: IUICfgAttributeBoolean) {
    super(api, element);
    this.initValueState();
  }
}
